import { Box, Typography } from "@mui/material";
import NotificationItem from "./NotificationItem";
import { NotificationProps } from "../common/redux/notificationActions";

const NotificationSection = ({
    title,
    data,
    onClick,
}: {
    title: string;
    data: NotificationProps[];
    onClick: (notification: NotificationProps) => void;
}) => (
    <Box>
        <Typography
            sx={{
                fontWeight: "bold",
                fontSize: "14px",
                color: "#00000",
                pl: 2,
                pt: 1,
                pb: 1,
                fontFamily: "Montserrat",
            }}
        >
            {title}
        </Typography>
        {data.map((notification) => (
            <NotificationItem
                key={notification.id}
                notification={notification}
                onClick={() => onClick(notification)}
            />
        ))}
    </Box>
);

export default NotificationSection;
